import React from 'react';
import {
	List,
	Filter,
	TextInput,
	Datagrid,
	TextField,
	TopToolbar,
	CreateButton,
	FunctionField,
} from 'react-admin';
import { Chip } from '@mui/material';
import { ConnectorStatusLst, IStatus } from '../../Services/connector';

// Champ personnalisé pour afficher le logo + nom
const LogoWithNameField = ({ record }: { record?: any }) => {
	if (!record) return null;
	console.log('record', record);
	const w = window as any;
	const logoUrl = `${w['FRONT_URL']}/img/connectors-logos/${record.sku}.svg`;

	return (
		<span style={{ display: 'flex', alignItems: 'center' }}>
			<img
				src={logoUrl}
				alt={`${record.name} logo`}
				style={{ width: 24, height: 24, marginRight: 8, objectFit: 'contain' }}
			/>
			{record.name}
		</span>
	);
};

LogoWithNameField.defaultProps = {
	addLabel: true,
};

const ConnectorFilter = (props: any) => (
	<Filter {...props}>
		<TextInput label="Search" source="q" alwaysOn />
	</Filter>
);

const ListActions = () => {
	return (
		<>
			<TopToolbar>
				<CreateButton />
			</TopToolbar>
		</>
	);
};

export const ConnectorList = (props: any) => (
	<List
		{...props}
		filters={<ConnectorFilter />}
		exporter={false}
		actions={<ListActions />}
	>
		<Datagrid rowClick={(id, basePath, record) => `${record.id}`}>
			<TextField source="id" />
			<FunctionField
				source="name"
				render={(record: any) => {
					if (!record) return null;
					const w = window as any;
					const logoUrl = `${w['FRONT_URL']}/img/connectors-logos/${record.sku}.svg`;
					return (
						<span style={{ display: 'flex', alignItems: 'center' }}>
							<img
								src={logoUrl}
								alt=""
								style={{
									width: 24,
									height: 24,
									marginRight: 8,
									objectFit: 'contain',
								}}
							/>
							{record.name}
						</span>
					);
				}}
			/>
			<FunctionField
				label="Statut"
				render={(record: any) => {
					const status: IStatus | undefined = ConnectorStatusLst.find(
						(s) => s.id === record?.status,
					);
					if (!status) return '—';
					return (
						<Chip
							label={status.name}
							size="small"
							sx={{ backgroundColor: status.color, color: 'white' }}
						/>
					);
				}}
			/>
			<TextField source="processVersion" />
			<TextField source="version" />
			<TextField source="sku" />
			<TextField source="skuParent" />
		</Datagrid>
	</List>
);
